import { css } from '@emotion/react';
import style from '../../../shared/global.style';

const card = css`
  background-color: var(--saa-white-color);
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 3px;
  box-shadow: 0px 1px 0px 0px var(--saa-primary-color-40);
`;
const info = css`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: flex-start;
    > div {
      flex: 1 1 0;
    }
  }
`;

const brand = css`
  border-bottom: solid 1px var(--saa-primary-color-10);

  div {
    border: none;
  }
`;

const buttonsContainer = css`
  display: flex;
  margin-top: 20px;

  button {
    width: 100%;
  }

  @media (min-width: 768px) {
    justify-content: flex-end;
    && {
      button {
        width: 125px;
      }
    }
  }
`;

const saveButton = css`
  && {
    &:not(:disabled),
    :not([disabled]) {
      ${style.primaryButton};
    }
  }
`;

const distributionListGroup = css`
  border-bottom: solid 1px var(--saa-primary-color-10);

  div {
    border: none;
  }
`;

const dropDown = css`
  &&&& {
    margin: 0 0 5px 0px;
    word-break: break-word;

    .menu .item {
      margin: 0;
      white-space: normal;
    }
  }
`;

const dropdownItemName = css`
  font-weight: 500;
  margin-bottom: 2px;
`;


const dropDownField = css`
  ${dropDown};

  &&&& {
    .label {
      font-size: 1em;
    }

    .item {
      font-size: 1em;
    }

    &.ui.dropdown > .text {
      margin: 0;
      padding: 0;
    }
  }
`;

const customDropDownField = css`
  ${dropDown};

  &&&& {
    .label {
      font-size: 1em;
    }

    .item {
      font-size: 1em;
    }

    &.ui.dropdown > .text {
      /* margin: .45238095em 0 .45238095em .64285714em;
      padding: 0; */
    }
  }
`;


const brandField = css`
  && {
    width: 100%;

  }
`;

const inputField = css`
 &&&&&& {
   margin: 0 0 5px 0px;
   padding-left: 0;
   &.ui.input > input {
    font-size: 1em;
  }
  }
`;

export default {
  card,
  info,
  brand,
  brandField,
  buttonsContainer,
  saveButton,
  distributionListGroup,
  dropDownField,
  customDropDownField,
  dropdownItemName,
  inputField,
};